import React from 'react';
import ecoForceIcon from '../assets/EcoForceIcon.avif';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const FooterContainer = styled(Box)(({ theme }) => ({
  py: 2,
  mt: 'auto',
  flexShrink: 0,
  bottom: 0,
  marginTop: '100px',
  width: '100%',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '50px',
    
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  pt: 2,
  pr: 3,
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'flex-end',
    pr: 0,
  },
 

}));

const Icon = styled(Box)(({ theme }) => ({
  ml: 2,
  height: 150, // Adjust the height as needed
  width: 'auto',
  [theme.breakpoints.down('sm')]: {
    height: 100, // Adjust the height for smaller screens
  },
  [theme.breakpoints.between('xs', 'md')]: {
    height: 90, // Adjust the height for 655px resolution
  },
}));

const CustomContainer = styled(Container)(({ theme }) => ({
  margin: 0,
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
}));

const LinkText = styled(Typography)(({ theme }) => ({
  variant: 'caption',
  color: theme.palette.text.secondary,
  fontSize: '12px',
  textDecoration: 'none',
  textAlign: 'left',
  margin: '20px 20px 0px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
    margin: '10px 10px 0px',
  },
}));

const CustomLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
  margin: '0 5px',
  [theme.breakpoints.down('sm')]: {
    margin: '0 2px',
  },
}));

const CopyrightText = styled(Typography)(({ theme }) => ({
  variant: 'caption',
  color: theme.palette.text.secondary,
  textAlign: 'left',
  width: '100%',
  fontFamily: 'DiodrumRegular',
  fontSize: '12px',
  margin: '20px 20px 10px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
    margin: '10px 10px 5px',
  },
}));

const CopyrightContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  ml: 20,
  [theme.breakpoints.down('sm')]: {
    ml: 0,
    width: '100%',
  },
}));

const Footer = () => {
  const location = useLocation();
  return (
    <FooterContainer component="footer">
      <IconContainer>
        {location.pathname !== '/home' && (
          <Icon
            component="img"
            src={ecoForceIcon} // Replace with the correct path to the image
            alt="EcoForce"
          />
        )}
      </IconContainer>
      <CustomContainer>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <LinkText>
              <CustomLink href="#">Legal Notice & Terms of Use</CustomLink> |{' '}
              <CustomLink href="#">Privacy</CustomLink> |{' '}
              <CustomLink href="#">Site Map</CustomLink> |{' '}
              <CustomLink href="#">Accessibility</CustomLink> |{' '}
              <CustomLink href="#">Cookie Preferences</CustomLink>
            </LinkText>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CopyrightContainer>
              <CopyrightText>
                © 2024 DuPont. All rights reserved. DuPont™, the DuPont Oval Logo, and all trademarks and service marks denoted with ™, ® or © are owned by affiliates of DuPont de Nemours, Inc., unless otherwise noted.
              </CopyrightText>
            </CopyrightContainer>
          </Grid>
        </Grid>
      </CustomContainer>
    </FooterContainer>
  );
};

export default Footer;